// extracted by mini-css-extract-plugin
module.exports = {"videoCropping":"style_videoCropping__1oOJw"};